import AuthenticatedUploadImage from "@/components/AuthenticatedUploadImage";
import { displayField } from "@/utils/propostaDisplay";
import {
  ASSINATURA_CORES,
  iniciaisNomeCompleto,
  formatCnpjParaExibicao,
} from "@/utils/empresaAssinatura";
import { cn } from "@/lib/utils";

/**
 * Bloco de assinatura para impressão/PDF (proposta, declaração/atestado).
 */
export default function BlocoAssinaturaEmpresa({ config, className, style }) {
  const { marca, avatarBg } = ASSINATURA_CORES;

  return (
    <div
      className={cn(
        "proposta-assinatura page-break-avoid break-inside-avoid mb-2 max-w-xl text-left text-[10pt] leading-[1.45] sm:leading-[1.5]",
        className
      )}
      style={style}
    >
      <p className="mb-2 text-slate-700">Atenciosamente,</p>

      <div className="w-full max-w-[13.5rem]">
        <div className="relative">
          {config.assinatura_url ? (
            <div className="flex justify-start leading-none">
              <AuthenticatedUploadImage
                src={config.assinatura_url}
                alt="Assinatura"
                className="block max-h-[70px] max-w-full object-contain object-bottom"
                style={{
                  maxHeight: "70px",
                  maxWidth: "260px",
                  display: "block",
                }}
              />
            </div>
          ) : null}
          <div
            className={cn(
              "h-[2px] w-full bg-slate-800",
              config.assinatura_url && "-mt-1.5 sm:-mt-2"
            )}
            aria-hidden
          />
        </div>
      </div>

      <div className="mt-2 flex gap-3 sm:gap-4">
        <div
          className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full text-sm font-bold tracking-tight ring-1 ring-blue-200/80"
          style={{ backgroundColor: avatarBg, color: marca }}
          aria-hidden
        >
          {iniciaisNomeCompleto(config.socio_nome)}
        </div>
        <div className="min-w-0 flex-1 space-y-1 pt-0.5">
          <div
            className="text-[12pt] font-bold leading-tight"
            style={{ color: marca }}
          >
            {displayField(config.socio_nome)}
          </div>
          <div className="proposta-linha-cargo text-[9.5pt] leading-snug text-slate-600 [overflow-wrap:normal] [word-break:normal]">
            {displayField(config.socio_cargo)}
          </div>
          <div
            className="text-[9.5pt] font-bold leading-snug"
            style={{ color: marca }}
          >
            {displayField(config.razao_social)}
          </div>
          <div
            className="text-[9.5pt] font-bold tabular-nums leading-snug"
            style={{ color: marca }}
          >
            CNPJ {formatCnpjParaExibicao(config.cnpj) ?? displayField(config.cnpj)}
          </div>
        </div>
      </div>
    </div>
  );
}
